import { AnimatePresence } from "framer-motion";
import { RouteProps } from "hoc/withRouter";
import { IRouteObj } from "interface/common";
import { Suspense } from "react";
import { Outlet, Route, Routes } from "react-router-dom";
import Page404 from "view/Page404/Page404";
import AuthValidator from "../component/AuthValidator/AuthValidator";
import Loader from "../component/Loader/Loader";
import { authRoutes } from "routes";

type IProps = Readonly<RouteProps>; // Mark the props as read-only

function AuthLayout(props: IProps) {
  return (
    <div
      id="container"
      className={
        "relative z-0 flex h-full w-full flex-col bg-light-grey-50 text-light-grey-1000 dark:bg-[#12171F] dark:text-white"
      }
    >
      <div className="flex h-full">
        <div className="h-full flex-1" id="content-to-export">
          <main className={`h-full flex-1 overflow-auto`}>
            <Suspense fallback={<Loader />}>
              <AnimatePresence>
                <Routes>
                  {authRoutes.map((route: IRouteObj) => {
                    return route.component ? (
                      <Route
                        key={route.path}
                        path={route.path}
                        element={
                          <AuthValidator
                            AuthorizedComponent={route.component}
                            urlPath={window.location.pathname}
                            props={route?.props}
                          />
                        }
                      />
                    ) : null;
                  })}
                  <Route path="*" element={<Page404 />} />
                </Routes>
              </AnimatePresence>
            </Suspense>
            <Outlet />
          </main>
        </div>
      </div>
    </div>
  );
}

export default AuthLayout;
